module.exports = __webpack_public_path__ + "static/media/spinner.235b9b3e.gif";